if (!customElements.get('couchery-driftnest-configurator')) {
  customElements.define('couchery-driftnest-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('.lf-config-data').textContent);
      this.values = {};
      this.controls = {};
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD', currencyDisplay:'code', minimumFractionDigits:0, maximumFractionDigits:2}).format(value / 100);
      const container = this.querySelector('.lf-config');
      for (const set of this.config.sets || []) {
        const label = document.createElement('label'); label.className = 'co-field';
        const name = document.createElement('span'); name.textContent = set.label + (set.required ? ' *' : '');
        const control = document.createElement(set.input === 'text' ? 'textarea' : 'select');
        control.dataset.setId = set.id; control.required = Boolean(set.required);
        if (set.input === 'text') { control.maxLength = 300; control.rows = 2; }
        else {
          if (true) { const blank = document.createElement('option'); blank.value = ''; blank.textContent = this.dataset.chooseLabel || 'Choose an option'; control.append(blank); }
          for (const choice of set.choices || []) {
            const option = document.createElement('option'); option.value = choice.id;
            option.textContent = choice.label + (choice.paid && Number.isInteger(choice.price) ? ' (+' + this.money(choice.price) + ')' : ''); control.append(option);
          }
          control.value = '';
        }
        this.values[set.id] = control.value; this.controls[set.id] = control;
        control.addEventListener('input', () => { this.values[set.id] = control.value; this.querySelector('.co-cart-review').hidden = true; this.updatePrice(); });
        control.addEventListener('change', () => { this.values[set.id] = control.value; this.querySelector('.co-cart-review').hidden = true; this.updatePrice(); });
        label.append(name, control);
        if (set.help) { const help = document.createElement('small'); help.textContent = set.help; label.append(help); }
        (set.input === 'text' ? this.querySelector('.dn-request-fields') : container).append(label);
      }
      this.quantity = this.querySelector('.co-qty');
      this.quantity.addEventListener('input', () => { this.querySelector('.co-cart-review').hidden = true; this.updatePrice(); });
      this.add = this.querySelector('.co-add');
      if (this.dataset.preview !== 'true') this.add.textContent = this.dataset.addLabel || 'Add configured sofa to cart';
      this.add.addEventListener('click', () => this.addConfiguration());
      const raw = JSON.parse(this.querySelector('.lf-data').textContent);
      this.rows = raw.map(CoucheryMaterials.classicRow).map((r,i) => ({...r,image:raw[i].image}));
      this.groups = ['Plush Chenille', ...CoucheryMaterials.groups(this.rows).filter(g => g !== 'Plush Chenille')];

      this.materials = this.querySelector('.lf-materials');
      this.grid = this.querySelector('.lf-swatches');
      this.search = this.querySelector('input[type=search]');
      this.hero = this.querySelector('.lf-hero');
      this.dialog = this.querySelector('dialog');
      this.groups.forEach(group => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lf-material';
        button.dataset.material = group;
        CoucheryMaterials.decorate(this, button, group, this.rows.filter(row => row.material === group).length);
        button.addEventListener('click', () => {
          this.search.value = '';
          this.chooseMaterial(group);
        });
        this.materials.append(button);
      });
      this.search.addEventListener('input', () => this.renderSwatches());
      this.querySelector('.dn-mobile-preview button').addEventListener('click', () => { if(this.current) {this.galleryItem={type:'image',src:this.current.image,alt:this.current.name,row:this.current};this.openGallery();} });
      this.querySelector('.lf-zoom').addEventListener('click', () => this.openGallery());
      const makeActualSwatch = parent => {
        const figure = document.createElement('figure'); figure.className = 'lf-loft-swatch'; figure.hidden = true;
        const photo = document.createElement('img'); photo.width = 180; photo.height = 180; photo.loading = 'lazy';
        const caption = document.createElement('figcaption'); caption.textContent = 'Actual fabric'; const crop=document.createElement('div');crop.className='dn-real-photo';crop.append(photo);figure.append(crop, caption); parent.append(figure); return figure;
      };
      this.actualSwatches = [makeActualSwatch(this.querySelector('.lf-stage')), makeActualSwatch(this.dialog)];
      this.querySelector('.lf-visual').addEventListener('click', event => {
        if (event.target.closest('.cch-gal')) this.actualSwatches.forEach(figure => { figure.hidden = true; });
      }, true);
      this.querySelector('.lf-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.setupGallery();
      this.activeMaterial = null;
      this.current = null;
      CoucheryMaterials.update(this, this.rows[0], this.rows);
      this.querySelector('.lf-material-help').textContent = 'Choose a material, then a colour. Included choices are listed first.';
      this.renderSwatches();
      this.updatePrice();
      const id = new URL(location.href).searchParams.get('variant');
      if (id && this.rows.some(row => row.id === id)) this.select(this.rows.find(row => row.id === id), false);
    }
    select(row, updateUrl = true) {
      if (!row) return;
      this.current = row;
      this.activeMaterial = row.material;
      this.querySelector('.lf-details').hidden = false;
      this.querySelector('.dn-stage-video').hidden = true;
      this.querySelector('.dn-stage-video').pause();
      this.galleryItem = {type:'image',src:row.image,alt:row.colour+' · '+row.material,row};
      CoucheryMaterials.update(this, row, this.rows);
      const logo = this.querySelector('.lf-stage-label');
      if (logo) logo.hidden = false;
      this.querySelector('.co-cart-review').hidden = true;
      this.updatePrice();
      this.materials.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.material === row.material)));
      this.hero.hidden = !row.image;
      this.querySelector('.lf-image-status').hidden = Boolean(row.image);
      this.hero.onerror = () => { this.hero.hidden = true; this.querySelector('.lf-image-status').hidden = false; };
      if (row.image) this.hero.src = row.image;
      this.actualSwatches?.forEach(figure => {
        const show = Boolean(row.swatch); figure.classList.toggle('dn-right-panel',['ED02','XT002','PN11'].includes(row.code));
        figure.querySelector('figcaption').textContent = row.material === 'Rubbed leather' ? 'Actual leather' : 'Actual fabric'; figure.hidden = !show;
        if (show) { const photo = figure.querySelector('img'); const source = new URL(row.swatch, location.origin); source.searchParams.set('width', '400'); photo.src = source.href; photo.alt = 'Actual '+row.material+' '+row.colour + ' ' + row.code + ' fabric photograph'; }
      });
      const mobile=this.querySelector('.dn-mobile-preview'); mobile.hidden=!row.image; if(row.image){mobile.querySelector('img').src=row.image;mobile.querySelector('img').alt=row.name;mobile.querySelector('span').textContent=row.colour;}
      this.hero.alt = row.name;
      this.querySelector('.lf-selected-name').textContent = row.colour;
      this.querySelector('.lf-selected-material').textContent = CoucheryMaterials.label(this, row.material) + (row.code ? ' · ' + row.code : '');
      this.querySelector('.lf-detail-name').textContent = row.colour;
      this.querySelector('.lf-code').textContent = row.code;
      this.querySelector('.lf-code').hidden = !row.code;
      this.querySelector('.lf-description').textContent = row.description || '';
      this.querySelector('.lf-description').hidden = !row.description || row.description === this.querySelector('.lf-material-help')?.textContent;
      this.querySelector('.lf-composition').textContent = row.composition || '';
      this.querySelector('.lf-care').textContent = row.care || '';
      this.querySelector('.lf-composition').closest('details').hidden = !row.composition;
      this.querySelector('.lf-care').closest('details').hidden = !row.care;
      const tags = this.querySelector('.lf-tags');
      tags.replaceChildren();
      (row.tags || []).filter(value => !/digital|colour preview|made to order/i.test(value)).slice(0,5).forEach(value => { const tag = document.createElement('span'); tag.className = 'lf-tag'; tag.textContent = value.trim(); tags.append(tag); });
      this.querySelector('.lf-zoom').disabled = !row.image;
      this.renderSwatches();
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', row.id); history.replaceState(null, '', url); }
    }
    updatePrice() {
      const selected = CoucheryOptions.selection(this.config, this.values);
      const base = CoucheryMaterials.base(this.rows);
      const quantity = Number(this.quantity.value);
      const qty = Number.isInteger(quantity) && quantity > 0 ? quantity : 1;
      const subtotal = (this.current ? this.current.price : base) + selected.surcharge;
      this.querySelector('.lf-price').textContent = (this.current ? '' : 'From ') + this.money(subtotal * qty);
      const ready = !!this.current && !selected.errors.length && Number.isInteger(quantity) && quantity > 0;
      this.querySelector('.lf-price-context').textContent = ready ? 'Your selected configuration · shipping included to most destinations' : 'Choose your material, colour, size and cushion firmness. No upgrades are selected for you.';
      this.querySelector('.lf-breakdown').textContent = [ 'Sofa '+this.money(base), ...(this.current && this.current.price > base ? [CoucheryMaterials.label(this,this.current.material)+' +'+this.money(this.current.price-base)] : []), ...selected.chosen.filter(x=>x.choice.paid).map(x=>x.choice.label+' +'+this.money(x.choice.price)) ].join(' · ');
      this.configSelection = selected;
      this.add.disabled = !ready || this.busy || !this.current.available || selected.chosen.some(x => x.choice.paid && !x.choice.available);
      this.querySelector('.co-message').textContent = ready ? '' : 'Choose size, firmness, material and colour to continue.';
    }
    async addConfiguration() {
      if (this.busy) return;
      if (!this.current) { this.querySelector('.co-message').textContent = 'Please choose your upholstery colour.'; return; }
      const preview = this.dataset.preview === 'true';
      const group = crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      const built = CoucheryOptions.build(this.config, this.current, this.values, Number(this.quantity.value), group, preview);
      const message = this.querySelector('.co-message');
      if (built.errors.length) { message.textContent = built.errors.join(' '); return; }
      if (preview) { this.showReview(built); return; }
      this.busy = true; this.add.disabled = true; message.textContent = this.dataset.addingLabel;
      const root = this.dataset.root || '/';
      let inserted = false;
      let parentKey = null;
      try {
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[built.items[0]]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add your configuration.');
        inserted = true;
        parentKey = result.items?.[0]?.key;
        if (!parentKey) throw new Error('Could not identify the configured sofa in the cart.');
        if (built.items.length > 1) {
          const addons = built.items.slice(1).map(item => { const {parent_id, ...child} = item; return {...child,parent_line_key:parentKey}; });
          const addResponse = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:addons})});
          const addResult = await addResponse.json();
          if (!addResponse.ok) throw new Error(addResult.description || addResult.message || 'Could not add the selected upgrades.');
        }
        const cartResponse = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'},cache:'no-store'});
        if (!cartResponse.ok) throw new Error('Please review your cart before trying again.');
        const cart = await cartResponse.json();
        const groupItems = cart.items.filter(item => item.properties?._couchery_config === group);
        const errors = CoucheryOptions.inspectCart({items:groupItems}, {[String(this.config.productId)]:this.config});
        if (groupItems.length !== built.items.length || errors.length) throw new Error('Your configuration needs review in the cart. ' + errors.join(' '));
        location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (inserted && parentKey) {
          try {
            const rollback = await fetch(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parentKey,quantity:0})});
            if (rollback.ok) inserted = false;
          } catch (_) { /* Keep the cart review link if cleanup could not be confirmed. */ }
        }
        message.textContent = error.message;
        if (inserted) {
          const link = document.createElement('a'); link.href = this.dataset.cartUrl; link.textContent = this.dataset.cartLabel || 'Review cart'; message.append(' ',link);
          this.add.disabled = true;
          return;
        }
        this.busy = false; this.add.disabled = false;
      }
    }
    showReview(built) {
      const box = this.querySelector('.co-cart-review'); box.replaceChildren(); box.hidden = false;
      const heading = document.createElement('h3'); heading.textContent = this.dataset.reviewHeading; box.append(heading);
      const row = (label, detail, amount, total = false) => {
        const line = document.createElement('div'); line.className = 'co-cart-line' + (total ? ' co-cart-total' : '');
        const text = document.createElement('span'); text.textContent = label;
        if (detail) { const small = document.createElement('small'); small.textContent = detail; text.append(small); }
        const price = document.createElement('span'); price.textContent = this.money(amount); line.append(text,price); box.append(line);
      };
      const qty = Number(this.quantity.value);
      row(this.dataset.productTitle, this.current.name + ' · ×' + qty, this.current.price * qty);
      for (const {set,choice} of this.configSelection.chosen) row(set.label, choice.label + ' · ×' + qty, (choice.paid ? choice.price : 0) * qty);
      const totalLabel = this.dataset.totalLabel || 'Total'; row(totalLabel,'',built.total,true);
      const note = document.createElement('p'); note.textContent = this.dataset.reviewNote; box.append(note);
      const text = Object.entries(this.configSelection.properties).filter(([key]) => !this.configSelection.chosen.some(({set}) => set.label === key));
      for (const [key,value] of text) { const p = document.createElement('p'); p.textContent = key + ': ' + value; box.append(p); }
      this.querySelector('.co-message').textContent = '';
      this.lastReviewPayload = built;
    }
    chooseMaterial(group) {
      this.activeMaterial = group; this.current = null;
      this.querySelector('.lf-details').hidden = true; this.querySelector('.dn-mobile-preview').hidden=true;
      this.materials.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.material === group)));
      const first = this.rows.find(r=>r.material===group);
      CoucheryMaterials.update(this,first,this.rows);
      if(group==='Plush Chenille') this.querySelector('.lf-material-help').textContent = 'Soft, plush chenille with a cosy hand-feel and subtle tonal texture. All 20 original colours are included.';
      if(group==='Performance Diamond') this.querySelector('.lf-material-help').textContent = 'Cat-scratch-resistant performance fabric with water and spill protection and a refined, soft surface. Included in the sofa price.';
      this.renderSwatches(); this.updatePrice();
    }
    setupGallery() {
      const raw = JSON.parse(this.querySelector('.dn-gallery-data').textContent);
      this.gallery = raw.filter((m,i) => i===0 || m.type==='video' || (m.alt||'').startsWith('DriftNest gallery'));
      this.galleryItem = this.gallery[0];
      const strip=this.querySelector('.dn-gallery');
      this.gallery.forEach((m,i)=>{const b=document.createElement('button'); b.type='button';b.setAttribute('aria-label',(m.type==='video'?'Play video: ':'View: ')+(m.alt||'Product image'));const img=document.createElement('img');img.src=m.preview;img.alt='';img.width=80;img.height=80;img.loading='lazy';b.append(img);if(m.type==='video'){const play=document.createElement('span');play.textContent='▶';b.append(play);}b.addEventListener('click',()=>this.showGalleryItem(m));strip.append(b);});
      this.showGalleryItem(this.gallery[0]);
      this.querySelector('.dn-stage-prev').addEventListener('click',()=>this.navigateGallery(-1));
      this.querySelector('.dn-stage-next').addEventListener('click',()=>this.navigateGallery(1));
      this.querySelector('.dn-prev').addEventListener('click',()=>this.navigateGallery(-1));
      this.querySelector('.dn-next').addEventListener('click',()=>this.navigateGallery(1));
      this.dialog.addEventListener('close',()=>this.querySelector('.dn-dialog-video').pause());
      this.dialog.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();this.navigateGallery(-1);}if(e.key==='ArrowRight'){e.preventDefault();this.navigateGallery(1);}});
    }
    showGalleryItem(m) {
      if(!m)return; this.galleryItem=m;
      const v=this.querySelector('.dn-stage-video'); v.pause();v.hidden=m.type!=='video';this.hero.hidden=m.type==='video';
      this.querySelector('.lf-image-status').hidden=true;
      if(m.type==='video'){v.src=m.src;v.poster=m.preview;this.querySelector('.lf-stage-label').hidden=true;v.play().catch(()=>{});}else{this.hero.src=m.src;this.hero.alt=m.alt||this.dataset.productTitle;this.querySelector('.lf-stage-label').hidden=false;}
      this.actualSwatches?.forEach(f=>{f.hidden=true;});
      this.querySelector('.lf-selected-name').textContent = (m.alt||'DriftNest').replace(/^DriftNest gallery — /,'');
      this.querySelector('.lf-selected-material').textContent = '';
      this.querySelector('.lf-zoom').disabled=false;
      if(this.dialog.open)this.fillDialog();
    }
    fillDialog() {
      const m=this.galleryItem;if(!m)return;
      const img=this.dialog.querySelector('img'),v=this.querySelector('.dn-dialog-video');v.pause();img.hidden=m.type==='video';v.hidden=m.type!=='video';
      if(m.type==='video'){v.src=m.src;v.poster=m.preview;}else{img.src=m.src;img.alt=m.alt||this.dataset.productTitle;}
      this.dialog.querySelector('.lf-dialog-caption').textContent=(m.alt||'DriftNest').replace(/^DriftNest gallery — /,'');
      const f=this.actualSwatches[1];f.hidden=!m.row?.swatch;
      f.classList.toggle('dn-right-panel',['ED02','XT002','PN11'].includes(m.row?.code));
      if(m.row?.swatch){f.querySelector('img').src=m.row.swatch;f.querySelector('img').alt='Actual '+m.row.material+' '+m.row.colour;f.querySelector('figcaption').textContent=m.row.material==='Rubbed leather'?'Actual leather':'Actual fabric';}
    }
    openGallery(){this.fillDialog();this.dialog.showModal();}
    navigateGallery(delta){
      const items=[...this.gallery];if(this.galleryItem?.row&&!items.some(m=>m.src===this.galleryItem.src))items.push(this.galleryItem);
      let i=items.findIndex(m=>m.src===this.galleryItem?.src);i=(i+delta+items.length)%items.length;this.showGalleryItem(items[i]);
    }
    renderSwatches() {
      const term = this.search.value.toLocaleLowerCase().trim();
      const all = this.rows.filter(row => row.material === this.activeMaterial);
      if (['Performance Diamond', 'Premium Natural', 'Loft Bouclé', 'Velour Suede', 'Cloudsoft Weave'].includes(this.activeMaterial)) all.sort((a,b) => Number(a.code.replace(/\D/g,'')) - Number(b.code.replace(/\D/g,'')));
      const matches = all.filter(row => (row.colour + ' ' + row.code).toLocaleLowerCase().includes(term));
      this.querySelector('.lf-count').textContent = this.activeMaterial ? matches.length + ' / ' + all.length : '';
      this.search.disabled=!this.activeMaterial;
      this.querySelector('.lf-empty').textContent = this.activeMaterial ? 'No matching colours. Try another name or code.' : 'Choose a material above to see its colours.';
      this.querySelector('.lf-empty').hidden = matches.length > 0;
      this.grid.replaceChildren();
      matches.forEach(row => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'lf-swatch'; button.dataset.variantId = row.id;
        button.setAttribute('aria-pressed', String(row.id === this.current?.id));
        button.setAttribute('aria-label', row.colour + (row.code ? ' — ' + row.code : ''));
        const image = document.createElement('img');
        if (row.swatch || row.image) { const thumbnail = new URL(row.swatch || row.image, location.origin); thumbnail.searchParams.set('width', '220'); image.src = thumbnail.toString(); }
        image.alt = ''; image.width = 110; image.height = 110; image.loading = 'lazy';
        const wrap=document.createElement('div');wrap.className='dn-real-photo'+(['ED02','XT002','PN11'].includes(row.code)?' dn-right-panel':'');wrap.append(image);
        const label = document.createElement('span'); label.className = 'lf-swatch-name'; label.textContent = row.colour;
        button.append(wrap, label); button.addEventListener('click', () => this.select(row)); this.grid.append(button);
      });
    }
  });
}







